// src/theme.ts
import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#0A2540", // Deep Enterprise Blue
      light: "#4267B2",
    },
    secondary: {
      main: "#635BFF", // Vibrant Innovation Purple/Blue
    },
    background: {
      default: "#F6F9FC",
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h2: {
      fontWeight: 800,
      letterSpacing: "-0.02em",
    },
    button: {
      textTransform: "none", // Modern startup look
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 8, // Slightly more rounded for a modern feel
  },
});
